import type { FC } from 'react';

import { ToastWrapper, UndoButton } from './styled';

interface IToast {
    title: string;
    // eslint-disable-next-line react/require-default-props
    handleUndo?: () => void;
}

export const Toast: FC<IToast> = ({ title, handleUndo }) => (
    <ToastWrapper>
        {title}
        {handleUndo && <UndoButton onClick={handleUndo}>Undo</UndoButton>}
    </ToastWrapper>
);
